import api from "../config/api/axiosConfig";
import { useCallback } from "react";
import { useFontenehus } from "../context/FontenehusContext";

// ✅ This hook wraps your API calls with fontenehusId automatically
export const useDailyMenuApi = () => {
  const { selectedFontenehus } = useFontenehus();

  const getDailyMenuByDate = useCallback(
    async (date: string) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");
      const response = await api.get(
        `/DailyMenu/${date}?fontenehusId=${selectedFontenehus.id}`,
      );
      return response;
    },
    [selectedFontenehus],
  );

  const updateDailyMenu = useCallback(
    async (date: string, payload: any) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");
      const response = await api.put(`/DailyMenu/${date}`, payload);
      return response;
    },
    [selectedFontenehus],
  );

  const getDailyMenuStatusesInRange = useCallback(
    async (from: string, to: string) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");
      const response = await api.get(
        `/DailyMenu/statusrange?from=${from}&to=${to}&fontenehusId=${selectedFontenehus.id}`,
      );
      return response;
    },
    [selectedFontenehus],
  );

  const deleteDailyMenuById = useCallback(
    async (id: number) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");
      const response = await api.delete(`/DailyMenu/${id}`);
      return response;
    },
    [selectedFontenehus],
  );

  const getDailyMenusByRange = useCallback(
    async (startDate: string, endDate: string) => {
      if (!selectedFontenehus) throw new Error("Ingen Fontenehus valgt");
      const response = await api.get(
        `/DailyMenu/menurange?start=${startDate}&end=${endDate}&fontenehusId=${selectedFontenehus.id}`,
      );
      return response;
    },
    [selectedFontenehus],
  );

  return {
    getDailyMenusByRange,
    getDailyMenuByDate,
    updateDailyMenu,
    getDailyMenuStatusesInRange,
    deleteDailyMenuById,
  };
};
